import "bootstrap/dist/css/bootstrap.min.css";
import "./How.css";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";

const How = () => {
    const [cookies, setCookie, removeCookie] = useCookies(null);
    const authToken = cookies.AuthToken;
    return (
        <div className={authToken ? "howto" : ""}>
            <div className={authToken ? "pt-3 text-white how howMargin" : "pt-3 text-white how"} style={{ backgroundColor: "#fe8402", textIndent: "0" }}>
                <div className={authToken ? "howTextsm" : "howText"} style={{ margin: "0 auto", width: "25%", paddingBottom: "0.05px" }}>
                    <ul style={{ boxShadow: "3px -3px 4px 4px #b7410e" }}>
                        <h1 className="text-center">How it works</h1>
                        <li>Login to your account using your email and password.</li>
                        <li>If you dont have an account, create an account on the signup (create a new account) page.</li>
                        <li>Once you log in, you will see questions other members have asked.</li>
                        <li>If you want to answer a question, click on the question you want to answer.</li>
                        <li>If you want to ask a question, click on the ask question button.</li>
                    </ul>
                </div>
            </div>
            {authToken && (
                <Link to="/">
                    <div className="text-center py-1" style={{ backgroundColor: "#4f77aa", color: "white" }}>
                        Back to Questions
                    </div>
                </Link>
            )}
        </div>
    );
};

export default How;
